import {
  CalendarOutlined,
  ContainerOutlined,
  DashboardOutlined,
  IdcardOutlined,
  ShopOutlined,
  TeamOutlined,
  ToolOutlined,
} from "@ant-design/icons";
import { Col, Menu, Row, Layout } from "antd";
import BindeleddetInternalLogo from "assets/images/bindeleddetLogo/BL_logo_internal_white.png";
import { Link, NavLink } from "react-router-dom";
import styled from "styled-components";

const { SubMenu } = Menu;

const { Sider } = Layout;

export const NAVMENU_WIDTH = 270;

const ScrollableSider = styled(Sider)`
  overflow-y: auto !important;
  overflow-x: hidden !important;

  /* Hide scrollbar for Chrome, Safari og Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for Firefox */
  scrollbar-width: none;

  /* Hide scrollbar for IE og Edge */
  -ms-overflow-style: none;
`;

export const MenuContent = ({ children, onSelect }: { children?: React.ReactNode; onSelect?: () => void }) => {
  return (
    <Row gutter={[0, 56]} justify="center">
      <Col>
        <Link to="/admin/" style={{ margin: "auto" }}>
          <img
            src={BindeleddetInternalLogo}
            alt="BL logo white"
            style={{
              position: "relative",
              height: "40px",
              top: "13px",
              right: "31px",
              display: "block",
            }}
          />
        </Link>
      </Col>
      <Col style={{ width: "100%" }}>
        <Menu
          mode="inline"
          theme="dark"
          defaultSelectedKeys={["1"]}
          style={{ height: "100%", border: "none", backgroundColor: "var(--primary-color)" }}
        >
          <Menu.Item key="1" icon={<DashboardOutlined />} onClick={onSelect}>
            <NavLink exact to="/admin/">
              Dashboard
            </NavLink>
          </Menu.Item>
          <SubMenu key="events-submenu" title="Arrangementer" icon={<CalendarOutlined />} style={{ padding: 0 }}>
            <Menu.Item key="2" onClick={onSelect}>
              <NavLink exact to="/admin/events/">
                Arrangementer
              </NavLink>
            </Menu.Item>
            <Menu.Item key="2-1" onClick={onSelect}>
              <NavLink exact to="/admin/locations/">
                Lokasjoner
              </NavLink>
            </Menu.Item>
          </SubMenu>
          <Menu.Item key="3" icon={<ShopOutlined />} onClick={onSelect}>
            <NavLink to="/admin/companies/">Bedrifter</NavLink>
          </Menu.Item>
          <SubMenu key="students-submenu" title="Studenter" icon={<TeamOutlined />} style={{ padding: 0 }}>
            <Menu.Item key="4" onClick={onSelect}>
              <NavLink to="/admin/students/">Studenter</NavLink>
            </Menu.Item>
            <Menu.Item key="4-1" onClick={onSelect}>
              <NavLink to="/admin/study-program-applications/">Søknader om linjebytte</NavLink>
            </Menu.Item>
          </SubMenu>
          <Menu.Item key="5" icon={<IdcardOutlined />} onClick={onSelect}>
            <NavLink to="/admin/members/">Medlemmer</NavLink>
          </Menu.Item>
          <SubMenu key="sub1" title="Ressurser" icon={<ContainerOutlined />} style={{ padding: 0 }}>
            <Menu.Item key="6" onClick={onSelect}>
              <NavLink to="/admin/resources/casebank/">Casebank</NavLink>
            </Menu.Item>
            <Menu.Item key="7" onClick={onSelect}>
              <NavLink to="/admin/resources/articles/">Artikler</NavLink>
            </Menu.Item>
            <Menu.Item key="8" onClick={onSelect}>
              <NavLink to="/admin/resources/publications/">Publikasjoner</NavLink>
            </Menu.Item>
          </SubMenu>
          <SubMenu key="sub2" title="Verktøy" icon={<ToolOutlined />} style={{ padding: 0 }}>
            <Menu.Item key="9" onClick={onSelect}>
              <NavLink to="/admin/tools/send-email/">Send e-post</NavLink>
            </Menu.Item>
            <Menu.Item key="10" onClick={onSelect}>
              <NavLink to="/admin/tools/analyse/">Analyse</NavLink>
            </Menu.Item>
            <Menu.Item key="11" onClick={onSelect}>
              <NavLink to="/admin/tools/booking-seasons/">Bookingsesonger</NavLink>
            </Menu.Item>
            <Menu.Item key="12" onClick={onSelect}>
              <NavLink to="/admin/tools/take-attendance-for-event/">Innslippsappen</NavLink>
            </Menu.Item>
            <Menu.Item key="13" onClick={onSelect}>
              <NavLink to="/admin/tools/push-notifications/">Push-notifikasjoner</NavLink>
            </Menu.Item>
          </SubMenu>
          <div style={{ width: "100%", textAlign: "center" }}>{children}</div>
        </Menu>
      </Col>
    </Row>
  );
};
export const NavMenu = () => {
  return (
    <ScrollableSider
      width={NAVMENU_WIDTH}
      breakpoint="md"
      collapsedWidth="0"
      trigger={null}
      style={{
        minHeight: "100vh",
        height: "100vh",
        position: "fixed",
        backgroundColor: "var(--primary-color)",
        boxShadow: "1px 0px 5px rgba(0, 0, 0, 0.1)",
      }}
    >
      <MenuContent />
    </ScrollableSider>
  );
};
